import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LorenAssetDetailsComponent } from "./components/loren-asset-details/loren-asset-details.component";
import { LorenAssetDetailsResolver } from "./loren-asset-details.resolver";
import { AssetFormComponent } from "../loren-assets/components/asset-form/asset-form.component";

const routes: Routes = [
  { path: 'new', component: AssetFormComponent },
  {
    path: ":id",
    children: [
      {
        path: "", resolve: {
          asset: LorenAssetDetailsResolver,
        }, component: LorenAssetDetailsComponent
      },
      { path: 'edit', component: AssetFormComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LorenAssetDetailsRoutingModule {
}
